"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ADD_TO_CART_BUTTON_STYLE", {
  enumerable: true,
  get: function () {
    return _StyleConstants.ADD_TO_CART_BUTTON_STYLE;
  }
});
Object.defineProperty(exports, "AVAILABILITY_LABEL", {
  enumerable: true,
  get: function () {
    return _availabilityLabel.AVAILABILITY_LABEL;
  }
});
Object.defineProperty(exports, "AVAILABILITY_TYPES", {
  enumerable: true,
  get: function () {
    return _TccConstants.AVAILABILITY_TYPES;
  }
});
Object.defineProperty(exports, "AVAILABLE_FOR_GRANULAR_ITC", {
  enumerable: true,
  get: function () {
    return _ItcConstants.AVAILABLE_FOR_GRANULAR_ITC;
  }
});
Object.defineProperty(exports, "AuctionTypes", {
  enumerable: true,
  get: function () {
    return _auctionTypes.AuctionTypes;
  }
});
Object.defineProperty(exports, "AvailabilityStatus", {
  enumerable: true,
  get: function () {
    return _availabilityStatus.AvailabilityStatus;
  }
});
Object.defineProperty(exports, "CONTENTFUL_LOCALES", {
  enumerable: true,
  get: function () {
    return _ContentfulConstants.CONTENTFUL_LOCALES;
  }
});
Object.defineProperty(exports, "DOMAIN_SOURCES", {
  enumerable: true,
  get: function () {
    return _domainSources.DOMAIN_SOURCES;
  }
});
Object.defineProperty(exports, "EXACT_MATCH_PRICE_STYLES", {
  enumerable: true,
  get: function () {
    return _StyleConstants.EXACT_MATCH_PRICE_STYLES;
  }
});
Object.defineProperty(exports, "EidConstants", {
  enumerable: true,
  get: function () {
    return _constants.EidConstants;
  }
});
Object.defineProperty(exports, "FreePrivacyDisabled", {
  enumerable: true,
  get: function () {
    return _constants.FreePrivacyDisabled;
  }
});
Object.defineProperty(exports, "HYDRA_TEST_URL", {
  enumerable: true,
  get: function () {
    return _constants.HYDRA_TEST_URL;
  }
});
Object.defineProperty(exports, "ITC", {
  enumerable: true,
  get: function () {
    return _ItcConstants.ITC;
  }
});
Object.defineProperty(exports, "LocalizationConstants", {
  enumerable: true,
  get: function () {
    return _constants.LocalizationConstants;
  }
});
Object.defineProperty(exports, "MarketHelper", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.MarketHelper;
  }
});
Object.defineProperty(exports, "Markets", {
  enumerable: true,
  get: function () {
    return _markets.Markets;
  }
});
Object.defineProperty(exports, "PhoenixEventMetadata", {
  enumerable: true,
  get: function () {
    return _PhoenixEventHelper.PhoenixEventMetadata;
  }
});
Object.defineProperty(exports, "SEARCH_STATUS", {
  enumerable: true,
  get: function () {
    return _searchStatus.SEARCH_STATUS;
  }
});
Object.defineProperty(exports, "adjustFontSize", {
  enumerable: true,
  get: function () {
    return _adjustFontSize.adjustFontSize;
  }
});
Object.defineProperty(exports, "alternateResellerBaseUrls", {
  enumerable: true,
  get: function () {
    return _UrlHelper.alternateResellerBaseUrls;
  }
});
Object.defineProperty(exports, "applyPrecision", {
  enumerable: true,
  get: function () {
    return _PriceHelper.applyPrecision;
  }
});
Object.defineProperty(exports, "calculateDomainPrices", {
  enumerable: true,
  get: function () {
    return _PriceHelper.calculateDomainPrices;
  }
});
Object.defineProperty(exports, "calculateFinalTermDisplay", {
  enumerable: true,
  get: function () {
    return _PriceHelper.calculateFinalTermDisplay;
  }
});
Object.defineProperty(exports, "calculatePriceSavingsDisplay", {
  enumerable: true,
  get: function () {
    return _PriceHelper.calculatePriceSavingsDisplay;
  }
});
Object.defineProperty(exports, "convertYearlyPriceToMonthlyPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.convertYearlyPriceToMonthlyPrice;
  }
});
Object.defineProperty(exports, "formatCurrency", {
  enumerable: true,
  get: function () {
    return _CurrencyHelper.formatCurrency;
  }
});
Object.defineProperty(exports, "formatDomainPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.formatDomainPrice;
  }
});
Object.defineProperty(exports, "formatProductPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.formatProductPrice;
  }
});
Object.defineProperty(exports, "getAddToCartTrackProps", {
  enumerable: true,
  get: function () {
    return _TrackHelper.getAddToCartTrackProps;
  }
});
Object.defineProperty(exports, "getAuctionInfo", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.getAuctionInfo;
  }
});
Object.defineProperty(exports, "getAvailLabel", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.getAvailLabel;
  }
});
Object.defineProperty(exports, "getBestValue", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getBestValue;
  }
});
Object.defineProperty(exports, "getCookie", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.getCookie;
  }
});
Object.defineProperty(exports, "getCurrency", {
  enumerable: true,
  get: function () {
    return _LocalizationHelper.getCurrency;
  }
});
Object.defineProperty(exports, "getCurrentPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getCurrentPrice;
  }
});
Object.defineProperty(exports, "getCurrentPriceByYears", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getCurrentPriceByYears;
  }
});
Object.defineProperty(exports, "getCurrentPriceDisplay", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getCurrentPriceDisplay;
  }
});
Object.defineProperty(exports, "getDiscountPriceByYearsAmount", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getDiscountPriceByYearsAmount;
  }
});
Object.defineProperty(exports, "getDomainEidPrefix", {
  enumerable: true,
  get: function () {
    return _EidHelper.getDomainEidPrefix;
  }
});
Object.defineProperty(exports, "getDomainMonthlyTerms", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.getDomainMonthlyTerms;
  }
});
Object.defineProperty(exports, "getDomainPriceInfo", {
  enumerable: true,
  get: function () {
    return _getDomainPriceInfo.getDomainPriceInfo;
  }
});
Object.defineProperty(exports, "getDomainStatus", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.getDomainStatus;
  }
});
Object.defineProperty(exports, "getDomainTypes", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.getDomainTypes;
  }
});
Object.defineProperty(exports, "getDueTodayPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getDueTodayPrice;
  }
});
Object.defineProperty(exports, "getEidCodes", {
  enumerable: true,
  get: function () {
    return _EidCodes.getEidCodes;
  }
});
Object.defineProperty(exports, "getEnv", {
  enumerable: true,
  get: function () {
    return _UrlHelper.getEnv;
  }
});
Object.defineProperty(exports, "getExactMatchAvailable", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.getExactMatchAvailable;
  }
});
Object.defineProperty(exports, "getExactMatchBuyEID", {
  enumerable: true,
  get: function () {
    return _EidHelper.getExactMatchBuyEID;
  }
});
Object.defineProperty(exports, "getImagesBaseUrl", {
  enumerable: true,
  get: function () {
    return _UrlHelper.getImagesBaseUrl;
  }
});
Object.defineProperty(exports, "getIsBrowserSupported", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.getIsBrowserSupported;
  }
});
Object.defineProperty(exports, "getIsVatIncludedInPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getIsVatIncludedInPrice;
  }
});
Object.defineProperty(exports, "getIscAndItc", {
  enumerable: true,
  get: function () {
    return _UrlHelper.getIscAndItc;
  }
});
Object.defineProperty(exports, "getItcExactMatch", {
  enumerable: true,
  get: function () {
    return _itcUtils.getItcExactMatch;
  }
});
Object.defineProperty(exports, "getLanguageData", {
  enumerable: true,
  get: function () {
    return _LocalizationHelper.getLanguageData;
  }
});
Object.defineProperty(exports, "getListPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getListPrice;
  }
});
Object.defineProperty(exports, "getListPriceByDiscount", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getListPriceByDiscount;
  }
});
Object.defineProperty(exports, "getListPriceDisplay", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getListPriceDisplay;
  }
});
Object.defineProperty(exports, "getListPriceDisplayDefault", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getListPriceDisplayDefault;
  }
});
Object.defineProperty(exports, "getLocaleFromMarket", {
  enumerable: true,
  get: function () {
    return _LocalizationHelper.getLocaleFromMarket;
  }
});
Object.defineProperty(exports, "getLongestTermDuration", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getLongestTermDuration;
  }
});
Object.defineProperty(exports, "getMarket", {
  enumerable: true,
  get: function () {
    return _LocalizationHelper.getMarket;
  }
});
Object.defineProperty(exports, "getMoneySavings", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getMoneySavings;
  }
});
Object.defineProperty(exports, "getMultiYearAnnualPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getMultiYearAnnualPrice;
  }
});
Object.defineProperty(exports, "getMultiYearFirstYearSalePriceDisplay", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getMultiYearFirstYearSalePriceDisplay;
  }
});
Object.defineProperty(exports, "getMultiYearMonthlyPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getMultiYearMonthlyPrice;
  }
});
Object.defineProperty(exports, "getMultiYearPercentageDiscount", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getMultiYearPercentageDiscount;
  }
});
Object.defineProperty(exports, "getMultiYearPriceDiscount", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getMultiYearPriceDiscount;
  }
});
Object.defineProperty(exports, "getOneYearTermCurrPriceDisplay", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getOneYearTermCurrPriceDisplay;
  }
});
Object.defineProperty(exports, "getOneYearTermCurrentPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getOneYearTermCurrentPrice;
  }
});
Object.defineProperty(exports, "getOptionsForTermsDropdown", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getOptionsForTermsDropdown;
  }
});
Object.defineProperty(exports, "getPercentageDiscount", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getPercentageDiscount;
  }
});
Object.defineProperty(exports, "getPercentageSavings", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getPercentageSavings;
  }
});
Object.defineProperty(exports, "getPriceByYearsAmount", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getPriceByYearsAmount;
  }
});
Object.defineProperty(exports, "getPriceInfo", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getPriceInfo;
  }
});
Object.defineProperty(exports, "getPrices", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getPrices;
  }
});
Object.defineProperty(exports, "getQualifiersTextId", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getQualifiersTextId;
  }
});
Object.defineProperty(exports, "getRenewalPrice", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getRenewalPrice;
  }
});
Object.defineProperty(exports, "getSalePriceDisplay", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getSalePriceDisplay;
  }
});
Object.defineProperty(exports, "getTLD", {
  enumerable: true,
  get: function () {
    return _UrlHelper.getTLD;
  }
});
Object.defineProperty(exports, "getUrlQueryParam", {
  enumerable: true,
  get: function () {
    return _UrlHelper.getUrlQueryParam;
  }
});
Object.defineProperty(exports, "getUrlQueryParams", {
  enumerable: true,
  get: function () {
    return _UrlHelper.getUrlQueryParams;
  }
});
Object.defineProperty(exports, "getVatPercentage", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getVatPercentage;
  }
});
Object.defineProperty(exports, "getYearTerm", {
  enumerable: true,
  get: function () {
    return _PriceHelper.getYearTerm;
  }
});
Object.defineProperty(exports, "is123Reg", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.is123Reg;
  }
});
Object.defineProperty(exports, "isAftermarketPremium", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isAftermarketPremium;
  }
});
Object.defineProperty(exports, "isAuction", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isAuction;
  }
});
Object.defineProperty(exports, "isAvailable", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isAvailable;
  }
});
Object.defineProperty(exports, "isBrowser", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isBrowser;
  }
});
Object.defineProperty(exports, "isPreReg", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isPreReg;
  }
});
Object.defineProperty(exports, "isPremium", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isAftermarketPremium;
  }
});
Object.defineProperty(exports, "isRegPremium", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isRegPremium;
  }
});
Object.defineProperty(exports, "isReseller", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isReseller;
  }
});
Object.defineProperty(exports, "isRestricted", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isRestricted;
  }
});
Object.defineProperty(exports, "isSafariBrowser", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isSafariBrowser;
  }
});
Object.defineProperty(exports, "isTaken", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.isTaken;
  }
});
Object.defineProperty(exports, "logEvent", {
  enumerable: true,
  get: function () {
    return _traffic.logEvent;
  }
});
Object.defineProperty(exports, "logImpression", {
  enumerable: true,
  get: function () {
    return _traffic.logImpression;
  }
});
Object.defineProperty(exports, "logSearchTermImpression", {
  enumerable: true,
  get: function () {
    return _traffic.logSearchTermImpression;
  }
});
Object.defineProperty(exports, "normalizeEidSegment", {
  enumerable: true,
  get: function () {
    return _normalizeEidSegment.default;
  }
});
Object.defineProperty(exports, "premiumDomainAvailableForBuyNow", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.premiumDomainAvailableForBuyNow;
  }
});
Object.defineProperty(exports, "renderAsPremium", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.renderAsPremium;
  }
});
Object.defineProperty(exports, "sanitizeHTML", {
  enumerable: true,
  get: function () {
    return _DomPurifyWrapper.sanitizeHTML;
  }
});
Object.defineProperty(exports, "sendConversationalSearchResultsEvent", {
  enumerable: true,
  get: function () {
    return _PhoenixEventHelper.sendConversationalSearchResultsEvent;
  }
});
Object.defineProperty(exports, "validBaseUrlMatches", {
  enumerable: true,
  get: function () {
    return _UrlHelper.validBaseUrlMatches;
  }
});
var _normalizeEidSegment = _interopRequireDefault(require("./normalize-eid-segment"));
var _UrlHelper = require("./UrlHelper");
var _TrackHelper = require("./TrackHelper");
var _traffic = require("./traffic");
var _auctionTypes = require("./constants/auctionTypes");
var _EidCodes = require("./constants/EidCodes");
var _availabilityStatus = require("./constants/availabilityStatus");
var _availabilityLabel = require("./constants/availabilityLabel");
var _ItcConstants = require("./constants/ItcConstants");
var _ContentfulConstants = require("./constants/ContentfulConstants");
var _markets = require("./constants/markets");
var _searchStatus = require("./constants/searchStatus");
var _LocalizationHelper = require("./LocalizationHelper");
var _constants = require("./constants");
var _TccConstants = require("./constants/TccConstants");
var _PhoenixEventHelper = require("./PhoenixEventHelper");
var _StyleConstants = require("./constants/StyleConstants");
var _domainSources = require("./constants/domainSources");
var _getDomainPriceInfo = require("./getDomainPriceInfo");
var _sharedFunctions = require("./sharedFunctions");
var _EidHelper = require("./EidHelper");
var _itcUtils = require("./itcUtils");
var _CurrencyHelper = require("./CurrencyHelper");
var _PriceHelper = require("./PriceHelper");
var _DomPurifyWrapper = require("./DomPurifyWrapper");
var _adjustFontSize = require("./adjustFontSize");